import React, { FC, useCallback } from 'react'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'

import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { Typography, Grid } from '@mui/material'

import { IUserWallet } from '@sparling/financial-common'

import { columns } from './WalletsList'
import { Loader } from '../../../../components/Loader'
import { IDataItem, TableComponent } from '../../../../components/Table'
import { getUserWalletsRequest } from '../../../../store/actions'
import { userWalletsIsLoading, getUserWalletsData } from '../../../../store/selectors'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    height: '100%',
  },
  titleWrap: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minWidth: 400,
  },
  table: {
    paddingTop: theme.spacing(2),
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
}))

export const Wallets: FC = () => {
  const classes = useStyles()
  const { idSf } = useParams<{ idSf: string }>()
  const dispatch = useDispatch()
  const isLoading = useSelector(userWalletsIsLoading)
  const { data: responseData } = useSelector(getUserWalletsData)
  const { items: userWalletsItems, meta: params } = responseData

  const loadClientsWallets = useCallback(
    (page: number) => {
      if (idSf) {
        // eslint-disable-next-line
        dispatch(getUserWalletsRequest({ idSf, page, count: 10 } as any))
      }
    },
    [dispatch, idSf],
  )

  if (isLoading) {
    return <Loader />
  }

  return (
    <Grid container className={classes.container}>
      <Grid container className={classes.titleWrap}>
        <Typography variant={'h6'}>Wallets</Typography>
      </Grid>

      <Grid container className={classes.table}>
        <TableComponent
          columns={columns}
          data={userWalletsItems as IDataItem<IUserWallet>[]}
          params={params}
          loading={isLoading}
          loadData={loadClientsWallets}
        />
      </Grid>
    </Grid>
  )
}
